module.exports = __webpack_public_path__ + "fonts/CrimsonText-Italic.f5487c6b.woff";